import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Centrifuge } from 'centrifuge'
import axios from '@/lib/axios'
import * as endpoints from '@/endpoints'
import useAuth from '@/hooks/useAuth'

const normalizeWsUrl = (wsUrl) => {
    if (
        typeof window !== 'undefined' &&
        window.location.protocol === 'https:' &&
        wsUrl?.startsWith('ws://')
    ) {
        return `wss://${wsUrl.slice(5)}`
    }

    return wsUrl
}

export const useNotificationSocket = () => {
    const { isAuthenticated } = useAuth()
    const queryClient = useQueryClient()

    useEffect(() => {
        if (!isAuthenticated) return

        const getToken = () =>
            axios.get(endpoints.NOTIFICATION_WS_TOKEN).then((r) => r.data.token)

        let isDisposed = false
        let centrifuge = null
        let sub = null

        const initialize = async () => {
            try {
                const { data } = await axios.get(endpoints.NOTIFICATION_WS_TOKEN)
                if (isDisposed) return

                centrifuge = new Centrifuge(normalizeWsUrl(data.ws_url), {
                    token: data.token,
                    getToken
                })
                sub = centrifuge.newSubscription(data.channel)
                sub.on('publication', () => {
                    queryClient.invalidateQueries({ queryKey: ['notifications'] })
                })
                sub.subscribe()
                centrifuge.connect()
            } catch (err) {
                if (!isDisposed) {
                    console.warn('Notification socket failed to connect', err)
                }
            }
        }

        initialize()

        return () => {
            isDisposed = true
            sub?.unsubscribe()
            centrifuge?.disconnect()
        }
    }, [isAuthenticated, queryClient])
}
